import React from 'react';
import { Link } from 'react-router-dom';
import stylesPlain from './plain.module.css';

import Field from './Field';
import SelectInstance from '../../modal/selectinstance/SelectInstance';
//import PopupMenu from '../popupmenu/PopupMenu';

import { getCurrentResource, getDefinedItem } from '../../util/tools';
import { performApiRequest, MASTER_LOAD_REF_API_URL, ENTITY_LOAD_LIST_API_URL } from '../../util/restapi';
import { IET_SET_VALUE } from '../../util/realm/instance';

import goIcon from '../../assets/icons/png24x24/go-jump.png';
import insertIcon from '../../assets/icons/png24x24/insert.png';
import linkIcon from '../../assets/icons/png24x24/link.png';
import clearIcon from '../../assets/icons/png24x24/edit-clear.png';

const MODE_INSERT = 'insert';
const MODE_LINK = 'link';

class FieldObject extends Field {
	
	selectInstanceRvContext = {
		rateView: null,
		form: null,
		formTitle: null, 
		data: null
	};
	selectionMode = '';
	resourceFieldObject = {}
	
	constructor(props) {
		super(props);
		this.resourceFieldObject = getCurrentResource().components.plain.FieldObject;
		this.state.isSelectInstanceModalOpen = false;
		this.state.dirtyCounter = 1;
	}

	handleInstanceChange = async (event) => {
		if( event.eventType == IET_SET_VALUE && event.field == this.field) {
			this.setState({ value: event.newValue });
		}
	}

	selectInstance = (refNode, mode) => {
		this.selectionMode = mode;
		this.selectInstanceRvContext.form = refNode.selectInstanceFormId;
		this.selectInstanceRvContext.formTitle = refNode.selectInstanceFormTitle;
		this.setState({ isSelectInstanceModalOpen: true });
	};
	onInstanceSelected = async (ids) => {
		if( ids.length == 0 )
			return;
			
		if( this.selectionMode == MODE_INSERT ) {
			let request = {
				listId: [ids[0]]
			}
			let response = await performApiRequest(ENTITY_LOAD_LIST_API_URL, request);
			if( ! response.success ) {
				this.props.plain.app.showResponse( response );
				return;
			}
			this.closeSelectInstance();
			let currentInstance = this.field.instance;
			let newField = currentInstance.createObjectField(this.field.model, response.data[0]);
			newField.parent = this.field.parent;
			this.field.parent.value[ this.field.model.fieldId ] = newField;
			this.field = newField;
	
			let plain = this.props.plain;
			plain.setState({
				instance: currentInstance, plainDirtyCounter: plain.state.plainDirtyCounter + 1, 
			});
			this.setState({dirtyCounter: this.dirtyCounter+1});
		} else if( this.selectionMode == MODE_LINK ) {
			let request = {
				id: ids[0]
			}
			let response = await performApiRequest(MASTER_LOAD_REF_API_URL, request);
			if( ! response.success ) {
				this.props.plain.app.showResponse( response );
				return;
			}
			this.closeSelectInstance();
			let objectRef = response.data;
			this.props.instance.setFieldValue( this.field, objectRef );
		}
	}
	clearLink = () => {
		let objectRef = {};
		this.props.instance.setFieldValue( this.field, objectRef );
	}
	closeSelectInstance = () => {
		this.setState({ isSelectInstanceModalOpen: false });
	}
	
	render() {
		
		let readOnly = this.state.readOnly;
		let valueHtml = null;
		let editToolsHtml = null;
		
		if(this.field && this.field.ref && this.props.refNodes) {
			let listObjectRefNode = this.props.refNodes;
			let fieldRef = this.field.ref;
			let objectRefNode = null;
			for(let item of listObjectRefNode) {
				if( item.classId == '*' || item.classId == fieldRef.className ) {
					objectRefNode = item;
					break;
				}
			}
			if( objectRefNode == null || ! this.field.ref.id ) {
				valueHtml = ( <span>{fieldRef.card}</span> );
			} else {
				let url = objectRefNode.plainFormPath + '/' + fieldRef.id;
				valueHtml = (
					<React.Fragment>
						<input type='text' readOnly={true} value={fieldRef.card} 
							style={{flexGrow: '1', height: '25px', marginRight: '5px', fontWeight: 'bold'}} />
						<button type='button' onClick={this.goToRef} title={this.resourceFieldObject.buttonGoToRefTooltip}>
							<Link to={url} target='_blank'><img src={goIcon} /></Link>
						</button>
					</React.Fragment>
				);
			}
			
			if( listObjectRefNode.length == 1 ) {
				let refNode = listObjectRefNode[0];
				editToolsHtml = (
					<div style={{display: 'flex', alignItems: 'center'}}>
						<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '10px'}}
							title={this.resourceFieldObject.buttonInsertTooltip} 
							onClick={ () => {this.selectInstance(refNode, MODE_INSERT)} }
							disabled={readOnly}
						>
							<img src={insertIcon} />
						</button>
						<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '10px'}}
							title={this.resourceFieldObject.buttonLinkTooltip} 
							onClick={ () => {this.selectInstance(refNode, MODE_LINK)} }
							disabled={readOnly}
						>
							<img src={linkIcon} />
						</button>
						<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '20px'}}
							title={this.resourceFieldObject.buttonClearTooltip} onClick={this.clearLink}
							disabled={readOnly}
						>
							<img src={clearIcon} />
						</button>
					</div>
				)
			}
		}
		
		
		let propsDivMain = getDefinedItem(this.props, ['styles','divMain'], {} );
		let divMainStyle = {...propsDivMain};
		divMainStyle.display = 'flex';
		if( ! divMainStyle.alignItems )
			divMainStyle.alignItems = 'center';
			
		return (
			<div style={divMainStyle}>
				{this.createLabel()}
				<div style={{display: 'flex', alignItems: 'center', flexGrow: '1'}}>
					{valueHtml}
				</div> 
				{editToolsHtml}
				<SelectInstance 
					isModalOpen={this.state.isSelectInstanceModalOpen} 
					closeModal={this.closeSelectInstance}
					title={this.selectInstanceRvContext.formTitle}
					onInstanceSelected={this.onInstanceSelected}
					rvContext = {this.selectInstanceRvContext}
				/>
			</div>
		)
	}
}

export default FieldObject;